import React, { Component } from 'react';
import { browserHistory, Link } from 'react-router';
import { connect } from 'react-redux';

import _ from 'lodash';

/* Actions */
import {
	updateBrochureParameter,
	updatePages,
	getOrgContactPointList,
	saveOrgContactPointList
} from '../../../redux/actions';

class BrochureStep2 extends Component {
    constructor(props) {
        super(props);
		this.updateParamOfPage = this.updateParamOfPage.bind(this);
		this.state = {pageTitleErrorDialog: '',};
    }
    handlePriceLevelChange(paramName, event) {
		let { brochure } = this.props.state;
		var pages = brochure.payload.brochure.pages;
		pages.map((item, index) => {
			item.price = (event.target.value === "NoPrice" || event.target.value === "ProductPrice")?'':item.price
			if(event.target.value === "PagePrice" || event.target.value === "NoPrice") {
				item.products.map((itm, ind) => {
					itm.price = ''
					return null;
				})
			}
			return null;
		});
		this.props.updatePages(pages);

        this.props.updateBrochureParameter({
			name: paramName,
			value: event.target.value
		})
    }
	updateParamOfPage(pageNumber, paramName, paramValue) {
		event.preventDefault();
		let { brochure } = this.props.state;
		var pages = brochure.payload.brochure.pages;
		pages.map((item, index) => {
			if(item.pageNumber === pageNumber) {
				item[paramName] = paramValue;
			}
			return null;
		});
		this.props.updatePages(pages);
	}
	handlePageTitleChange(pageNumber, paramName, event) {
		this.updateParamOfPage(pageNumber, paramName, event.target.value);
	}
	/*new brochure change*/
	handleBrochureDividerTemplateOptions(pageNumber, event) {
		event.preventDefault();
		let { brochure } = this.props.state;
		const { dividerTemplateOptions } = brochure;
		let selectedDividerTemplate = dividerTemplateOptions.find((template) => template.dividerTemplateName == event.target.value);
		this.updateParamOfPage(pageNumber, "selectedBrochureDividerTemplate", selectedDividerTemplate);
	}
	/*end brochure change*/
	handlePagePriceChange(pageNumber, paramName, event) {
		this.updateParamOfPage(pageNumber, paramName, event.target.value);
	}
	handleContinue(event) {
		event.preventDefault();
		let { brochure } = this.props.state;
		const self = this,
		 	{ selectedAccount } = self.props.state.user,
			partyId = selectedAccount.PERSON_PARTY_ID | selectedAccount.PARTYID.toString(),
			soldToAddresses = self.props.getAddressesByCategory('SOLD_TO');

		let	siteId = '';
		if(soldToAddresses.length > 0) {
			siteId = soldToAddresses[0].SITEID;
		}
		var pageTitleError = false;
		let pattern = /^[^&\n]*?(?:\s&[^&\n]*)*$/
		brochure.payload.brochure.pages.map((item, index) => {
			if(!pattern.test(item.pageTitle)){
				pageTitleError = true;
			}
			return null;
		});
		if(pageTitleError){
			self.setState({
	  		  pageTitleErrorDialog: "Error in page title. Please include a space before &."
			})

			return null;
		}
		self.props.getOrgContactPointList(`requestType=getOrgContactPointList&partyId=${partyId}&siteId=${siteId}`, response => {
			if(response.status && response.responseObject) {
				self.props.saveOrgContactPointList(response);
			}
			browserHistory.push("/create-brochure-step3");
		});
	}
	onKeyValidateNumeric(e) {
		if(
			(e.charCode === 46 && e.charCode !== 44 && !(e.target.value !== '' && e.target.value.indexOf(".") === -1))
			||
			(e.charCode === 44 && e.charCode !== 46 && !(e.target.value !== '' && e.target.value.indexOf(",") === -1))
			||
			(e.charCode !== 46 && e.charCode !== 44 && !(e.charCode > 47 && e.charCode < 58))
			||
			(e.target.value.indexOf(".") !== -1 && e.target.value.substring(e.target.value.indexOf(".")).length - 1 === 2)
			||
			(e.charCode === 44 && (e.target.value.indexOf(".") !== -1 || e.target.value.indexOf(",") !== -1))
			||
			(e.charCode === 46 && (e.target.value.indexOf(",") === e.target.value.length - 1))
		)  {
            e.preventDefault();
        }
    }
	handleProductPriceChange(pageNumber, productNumber, paramName, event) {
		event.preventDefault();
		let { brochure } = this.props.state;
		var pages = brochure.payload.brochure.pages;
		pages.map((item, index) => {
			if(item.pageNumber === pageNumber) {
				item.products.map((itm, ind) => {
					if(itm.productNumber === productNumber) {
						itm[paramName] = event.target.value
					}
					return null;
				});
			}
			return null;
		});
		this.props.updatePages(pages);
	}
	componentDidMount() {
		window.scrollTo(0, 0);
		if(this.props.state.brochure.selectedItems.length === 0) {
			//Redirect to list page if user directly comes on this page
			browserHistory.push("/list");
		}
	}
    render() {
		let { brochure } = this.props.state;
{/*new brochure single change*/}
		const { dividerTemplateOptions } = brochure;
        return (
            <div>
                <div className="push"><h1>{brochure.payload.brochure.brochureId?"Edit":"Create"} Brochure</h1></div>
                <div className="floatLeft">
                    <h2 className="pageTitle">Step 2 of 4: Add Pricing and Supplemental pages <i className="unbold">(Optional)</i></h2>
                </div>
                <hr className="clear" />
                <div className="floatLeft" style={{ padding: '5px 20px 20px' }}>
                    <input type="radio" name="toPriceOrNotToPrice" id="toPriceOrNotToPrice1" defaultValue="NoPrice" defaultChecked={brochure.payload.brochure.priceLevel==="NoPrice"?true:false} onClick={this.handlePriceLevelChange.bind(this, 'priceLevel')} />
                    <label htmlFor="toPriceOrNotToPrice1">Don’t add price to this brochure</label>
                </div>
                <div className="floatLeft" style={{ padding: '5px 20px 20px' }}>
                    <input type="radio" name="toPriceOrNotToPrice" id="toPriceOrNotToPrice2" defaultValue="ProductPrice" defaultChecked={brochure.payload.brochure.priceLevel==="ProductPrice"?true:false} onClick={this.handlePriceLevelChange.bind(this, 'priceLevel')} />
                    <label htmlFor="toPriceOrNotToPrice2">Add a price for each product</label>
                </div>
                <div className="floatLeft" style={{ padding: '5px 20px 20px' }}>
                    <input type="radio" name="toPriceOrNotToPrice" id="toPriceOrNotToPrice3" defaultValue="PagePrice" defaultChecked={brochure.payload.brochure.priceLevel==="PagePrice"?true:false} onClick={this.handlePriceLevelChange.bind(this, 'priceLevel')} />
                    <label htmlFor="toPriceOrNotToPrice3">Add a price for each page</label>
                </div>
                <div className="clear push" />
				<p className="bold red">{this.state.pageTitleErrorDialog}</p>
                <form className="addPricingForm" onSubmit={this.handleContinue.bind(this)} name="addPricingForm" id="addPricingForm">
					{this.props.state.brochure.payload.brochure.pages.map((item, index) => {
{/*new brochure change*/}
						if(!item.selectedBrochureDividerTemplate){
							item.selectedBrochureDividerTemplate = {dividerTemplateName : "None"};
						}
						return <table key={index} className="addPricingPageTable dataTableType2">
							
                            <thead>
								{/*new brochure change*/}
								<tr>
									<th>
										<span style={{display:"flex",width:"250px"}}>Insert Brand/Solution page before this page</span>
									</th>
									<th colSpan="2">
										{dividerTemplateOptions && dividerTemplateOptions.length > 0 && <select value={item.selectedBrochureDividerTemplate.dividerTemplateName} onChange={this.handleBrochureDividerTemplateOptions.bind(this, item.pageNumber)} name="selectedDividerTemplateOption" className="brochureDividerOptionsTemplate">
												{dividerTemplateOptions.map((item, index) => {
													return <option value={item.dividerTemplateName} key={(index + 1)}>{item.dividerTemplateName}</option>
												})}
											</select>
										}
									</th>
								</tr>
								

                                <tr>
                                    <th colSpan={2}><span style={{display:"-webkit-inline-box",width:"265px"}}>Page {item.pageNumber}</span> <input type="text" style={{position:"relative", right:"4px",width:"222px"}} name={"page"+(index+1)+"title"} maxLength={20} onBlur={this.handlePageTitleChange.bind(this, item.pageNumber, "pageTitle")} defaultValue={item.pageTitle} /></th>
{/*end brochure change*/}
                                    <th className="price">
                                        {brochure.payload.brochure.priceLevel === "PagePrice"
											?<span className="tpontp_3">
                                                $ <input className="priceInput" type="text" name={"page_"+item.productNumber} onKeyPress={this.onKeyValidateNumeric.bind(this)} onChange={this.handlePagePriceChange.bind(this, item.pageNumber, "price")} defaultValue={item.price} />
                                            </span>
											:null
										}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
								{item.products.map((itm, ind) => {
									return <tr key={ind}>
                                        <td className="product"><Link className="sku" to={'/product-specs/product-number/'+itm.productNumber}>{itm.productNumber}</Link></td>
                                        <td className="description">{itm.productName}</td>
                                        <td className="price">
											{brochure.payload.brochure.priceLevel === "ProductPrice"
												?<span className="tpontp_2">
													$ <input className="priceInput" type="text" name={"price_"+itm.productNumber} onKeyPress={this.onKeyValidateNumeric.bind(this)} defaultValue={itm.price} onBlur={this.handleProductPriceChange.bind(this, item.pageNumber, itm.productNumber, "price")} />
												</span>
												:null
											}
                                        </td>
                                    </tr>
								})}
                            </tbody>
                        </table>
					})}
                    <p className="textRight">
                        <input type="submit" value="Continue" />
                    </p>
                </form>
            </div>
        );
    }
};
const mapStateToProps = (state) => {
    return { state };
};
const mapDispatchToProps = (dispatch) => ({
	updatePages: (payload) => dispatch(updatePages(payload)),
	updateBrochureParameter: (payload) => dispatch(updateBrochureParameter(payload)),
	getOrgContactPointList: (payload, callback) => dispatch(getOrgContactPointList(payload, callback)),
	saveOrgContactPointList: (payload) => dispatch(saveOrgContactPointList(payload))
});

BrochureStep2 = connect(mapStateToProps, mapDispatchToProps)(BrochureStep2);
export default BrochureStep2;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Brochure/step2.js